// extracted by mini-css-extract-plugin
export default {"descriptionLabel":"boats_descriptionLabel__P4U6t"};